import { P } from "@/lib/styles";
import styled from "styled-components";

// https://www.figma.com/file/16YSFRr06xdFYJFqNgvv41/Bormioli-Product-Design?node-id=52%3A1571
export const Container = styled.div`
  padding: 1.5rem 0;
  font-weight: 400;
  font-size: 1.25rem; //OK
  line-height: 1.2;
  text-align: center;
`;
